import styles from "./TrendingSectionSkeleton.module.css";
import skeletonStyles from "../../styles/Skeleton.module.css";

export default function TrendingSectionSkeleton() {
  return (
    <section className={styles.trendingSection}>
      <div className={styles.categorySection}>
        <div className={styles.categoryHeader}>
          <div
            className={`${skeletonStyles.skeletonTitle} ${styles.titleSkeleton}`}
          />
          <div
            className={`${skeletonStyles.skeletonText} ${styles.subtitleSkeleton}`}
          />
        </div>
      </div>
      <div className={styles.trendingGrid}>
        {[...Array(6)].map((_, index) => (
          <div key={index} className={styles.trendingCard}>
            <div className={styles.imageContainer}>
              <div className={skeletonStyles.skeletonImage} />
              <div className={styles.tagWrapper}>
                <div
                  className={`${skeletonStyles.skeleton} ${styles.positionBadge}`}
                />
              </div>
            </div>
            <div className={styles.bookInfo}>
              <div className={styles.header}>
                <div
                  className={`${skeletonStyles.skeletonText} ${styles.titleSkeleton}`}
                />
                <div
                  className={`${skeletonStyles.skeletonText} ${styles.authorSkeleton}`}
                />
              </div>
              <div className={styles.meta}>
                <div
                  className={`${skeletonStyles.skeleton} ${styles.ratingSkeleton}`}
                />
                <div
                  className={`${skeletonStyles.skeleton} ${styles.buttonSkeleton}`}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
